import React from 'react';

export const TextTableColumn = (props) => {
    return <span>{props.Value}</span>;
}